import { render, staticRenderFns } from "./Lckv-About.vue?vue&type=template&id=26e46acd&scoped=true&"
import script from "./Lckv-About.vue?vue&type=script&lang=js&"
export * from "./Lckv-About.vue?vue&type=script&lang=js&"
import style0 from "./Lckv-About.vue?vue&type=style&index=0&id=26e46acd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e46acd",
  null
  
)

export default component.exports